<template>
  <div class="bg-gray">
    <div class="form-content">
      <el-form
          :model="formData"
          ref="ruleForm"
          :rules="rules"
          label-width="120px"
          class="demo-ruleForm"
      >
        <el-divider>{{ $T('联系人') }}</el-divider>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item :label="$T('姓')" prop="surname">
              <el-input
                  type="text"
                  :placeholder="$T('请输入姓')"
                  v-model="formData.surname"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$T('名')" prop="given_name">
              <el-input
                  type="text"
                  :placeholder="$T('请输入名')"
                  v-model="formData.given_name"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item :label="$T('邮箱')" prop="email">
              <el-input
                  type="text"
                  :placeholder="$T('请输入邮箱')"
                  v-model="formData.email"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" class="phone-el-col">
            <el-form-item :label="$T('电话')" required class="phone-form-item-wrap">
              <div class="phone-inline-row">
                <el-form-item prop="phone_pre" class="phone-form-item-inner phone-form-item-pre">
                  <el-select
                    v-model="formData.phone_pre"
                    :placeholder="$T('区号')"
                    filterable
                    style="width: 100%"
                  >
                    <el-option
                      v-for="opt in phoneCountryOptions"
                      :key="opt.k + '|' + opt.c"
                      :label="phoneOptionLabel(opt)"
                      :value="phoneOptionValue(opt)"
                    />
                  </el-select>
                </el-form-item>
                <el-form-item prop="lxphone" class="phone-form-item-inner phone-form-item-num">
                  <el-input
                    type="text"
                    :placeholder="$T('请输入电话号码')"
                    v-model="formData.lxphone"
                  />
                </el-form-item>
              </div>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item :label="$T('地址')" prop="address">
              <el-input
                  type="textarea"
                  :rows="3"
                  :placeholder="$T('请输入协会地址')"
                  v-model="formData.address"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col class="footer-button">
            <el-button type="primary" @click="submitForm('ruleForm')" :loading="saveLoading">{{ $T('下一步') }}
            </el-button>
          </el-col>
        </el-row>
      </el-form>
      <LoginDialog :show="loginShow" @loginSuccess="loginSuccess" @loginCancel="loginCancel"/>
    </div>
  </div>
</template>
<style scoped>
.phone-el-col {
  min-width: 0;
}
/* 电话行限制在右半列内，右侧与下方全宽 Address 对齐 */
.phone-form-item-wrap >>> .el-form-item__content {
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;
}
.phone-inline-row {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  flex-wrap: nowrap;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;
}
.phone-form-item-wrap >>> .phone-inline-row > .el-form-item {
  margin-bottom: 0;
  max-width: 100%;
  min-width: 0;
}
.phone-form-item-wrap >>> .phone-inline-row > .el-form-item > .el-form-item__content {
  margin-left: 0 !important;
  max-width: 100%;
  min-width: 0;
}
.phone-form-item-pre {
  flex: 0 0 108px;
  width: 108px;
  max-width: 108px;
  min-width: 96px;
  margin-right: 10px;
}
.phone-form-item-pre >>> .el-select {
  display: block;
  width: 100% !important;
  max-width: 100%;
}
.phone-form-item-num {
  flex: 1;
  min-width: 0;
  max-width: 100%;
}
.phone-form-item-num >>> .el-input {
  width: 100%;
  max-width: 100%;
}
</style>
<script>
import Vue from 'vue';
import area from "../../../utils/area";

import {Cell,Field,Area,Form,Divider, CellGroup,RadioGroup,Radio,Icon,Dialog, Toast, Popup, Picker, Sidebar, SidebarItem, Tag, Stepper ,Switch ,Button} from 'vant';
import LoginDialog from '@/components/LoginDialog.vue';
import { PHONE_COUNTRY_OPTIONS } from '@/utils/phoneCountryOptions';

Vue.use(Cell).use(CellGroup).use(Form).use(Divider).use(Area).use(RadioGroup).use(Dialog).use(Radio).use(Icon).use(Toast).use(Popup).use(Picker).use(Sidebar).use(SidebarItem).use(Tag).use(Stepper).use(Field)
    .use(Switch).use(Button);
export default {
  name: 'SaiApplyFormStep1',
  components: {
    LoginDialog
  },
  data: function () {
    return {
      loginShow: false,
      saveLoading: false,
      saiqu_id: this.$route.query.saiqu_id,
      showNumTypePicker: false,
      numTypeColumns: ['身份证', '护照', '其他'],
      showArea: false,
      areaList: {},
      areaValue: '',
      submitType: '',
      phoneCountryOptions: PHONE_COUNTRY_OPTIONS,
      formData: {
        id: 0,
        username: '',
        saiqu_name: '',
        numTypeName: '身份证',
        danwei: '',
        ldcardtype: 1,
        ldsex: 1,
        phone_pre: '+86|中国',
        surname: '',
        given_name: '',
        email: '',
        lxphone: '',
        address: '',
      },
    }
  },
  computed: {
    rules() {
      return {
        surname: [
          { required: true, message: this.$T('请输入姓'), trigger: 'blur' }
        ],
        given_name: [
          { required: true, message: this.$T('请输入名'), trigger: 'blur' }
        ],
        phone_pre: [
          { required: true, message: this.$T('请选择地区代码'), trigger: 'change' }
        ],
        lxphone: [
          { validator: this.validateInternationalPhone, trigger: 'blur' },
        ],
        email: [
          { required: true, message: this.$T('请输入正确的邮箱'), trigger: 'blur' },
          { validator: this.validateEmailFormat, trigger: 'blur' },
        ],
        address: [
          { required: true, message: this.$T('请输入协会地址'), trigger: 'blur' },
        ]
      };
    },
  },
  filters: {},
  mounted() {
    let that = this;
    that.areaList = area;
    that.formData.id = this.$route.query.id;
    document.title = this.$T('秩序册填写');
    that.fetch();
  },
  watch: {
    formData() {
    }
  },
  destroyed() {
  },
  methods: {
    phoneOptionLabel(opt) {
      return opt.c;
    },
    phoneOptionValue(opt) {
      return opt.c + '|' + opt.k;
    },
    stripPhonePreForPayload(val) {
      if (!val) {
        return '+86';
      }
      const s = String(val);
      const i = s.indexOf('|');
      if (i !== -1) {
        return s.slice(0, i);
      }
      return s;
    },
    normalizePhonePreAfterFetch() {
      let raw = this.formData.phone_pre;
      if (!raw) {
        this.$set(this.formData, 'phone_pre', '+86|中国');
        return;
      }
      raw = String(raw);
      if (raw.indexOf('|') !== -1) {
        const parts = raw.split('|');
        const dial = parts[0];
        const name = parts[1];
        const ok = PHONE_COUNTRY_OPTIONS.some(function (o) {
          return o.c === dial && o.k === name;
        });
        if (ok) {
          return;
        }
      }
      const dialOnly = raw.indexOf('|') !== -1 ? raw.split('|')[0] : raw;
      const matches = PHONE_COUNTRY_OPTIONS.filter(function (o) {
        return o.c === dialOnly;
      });
      if (matches.length >= 1) {
        this.$set(this.formData, 'phone_pre', matches[0].c + '|' + matches[0].k);
      } else {
        this.$set(this.formData, 'phone_pre', '+86|中国');
      }
    },
    validateInternationalPhone(rule, value, callback) {
      if (!value) {
        callback(new Error(this.$T('请输入手机号')));
        return;
      }
      if (!/^\d{6,20}$/.test(value)) {
        callback(new Error(this.$T('手机号格式不正确')));
        return;
      }
      callback();
    },
    validateEmailFormat(rule, value, callback) {
      const reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
      if (!reg.test(value)) {
        callback(new Error(this.$T('邮箱格式不正确')));
      } else {
        callback();
      }
    },
    fetch() {
      let that = this;
      that.$api.get('/api/isai/step1Detail', {
        saiqu_id: that.saiqu_id,
        id: that.formData.id,
      }, (res) => {
        if(!res.data.caipan) {
          that.formData = Object.assign(that.formData, res.data);
        } else {
          that.formData = res.data;
        }
        that.normalizePhonePreAfterFetch();

        if (that.formData.un_complete > 0) {
          that.$confirm(
            that.$T('建议您选择继续未完成的报名'),
            that.$T('您有未完成的报名'),
            {
              confirmButtonText: that.$T('继续未完成的报名'),
              cancelButtonText: that.$T('重新报名'),
              showClose: false,
              closeOnPressEscape: false,
              closeOnClickModal: false,
            }).then(() => {
              that.jumToOld();
            }).catch(() => {
            });
        }

      }, (res) => {
        console.log('没有登录');
        if (res.code == 401 || res.code == 402) {
          if (window.isApp()) {
            rbLink({
              name: 'login', 'query': {}
            }, 'replace');
            return false;
          }
          that.loginShow = true
        } else {
          Toast(res.msg)
        }
      })
    },
    onQuestion() {
      console.log('onQuestion')
    },

    submitForm(formName) {
      const that = this;
      that.$refs[formName].validate((valid) => {
        if (valid) {
          that.saveLoading = true;
          const payload = Object.assign({}, that.formData, {
            phone_pre: that.stripPhonePreForPayload(that.formData.phone_pre),
            surname: (that.formData.surname || '').trim(),
            given_name: (that.formData.given_name || '').trim(),
          });
          that.$api.post("/api/isai/baoming", payload, (res) => {
            that.saveLoading = false;

            appEvent({
              name: 'saiApplyDetailReload',
              query: {
              }
            });
            setTimeout(function () {
              rbLink({
                'name' : 'ISaiApplyDetail',
                'query':{
                  id:res.data.id
                }
              },'replace')
            },50);
          }, (res) => {
            if(res.code == 505){
              Dialog.alert({
                title: that.$T('等待认证'),
                message: res.msg,
                confirmButtonText: that.$T('查看详情')
              }).then(() => {
                rbLink({
                  name:'CertDanwei'
                })
              });
            }else{
              that.$message.error(res.msg)
            }
            that.saveLoading = false;
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    onNumTypeConfirm(value, index) {
      this.formData.numTypeName = value;
      this.formData.ldcardtype = index + 1;
      this.showNumTypePicker = false;
    },
    jumToOld(id) {
      rbLink({
        name: 'ISaiApplyList'
      }, 'replace')
    },
    onSubmit(values) {
      let that = this;
      that.formValidate = true;
      for (let field in that.formData) {
        if (field === 'phone_pre' && !that.formData.phone_pre) {
          Toast(that.$T('请选择地区代码'));
          return;
        }
      }
      that.saveLoading = true;
      const payload = Object.assign({}, that.formData, {
        phone_pre: that.stripPhonePreForPayload(that.formData.phone_pre),
        surname: (that.formData.surname || '').trim(),
        given_name: (that.formData.given_name || '').trim(),
      });
      that.$api.post('/api/isai/baoming', payload, (res) => {
        that.saveLoading = false;

        appEvent({
          name: 'saiApplyDetailReload',
          query: {}
        });
        setTimeout(function () {
          rbLink({
            'name': 'ISaiApplyDetail',
            'query': {
              id: res.data.id
            }
          }, 'replace')
        }, 50);
      }, (res) => {
        if (res.code == 505) {
          Dialog.alert({
            title: that.$T('等待认证'),
            message: res.msg,
            confirmButtonText: that.$T('查看详情')
          }).then(() => {
            rbLink({
              name: 'CertDanwei'
            })
          });
        } else {
          Toast.fail(res.msg);
        }
        that.saveLoading = false;
      })
    },
    save(values) {
      this.submitType = 'save';
    },
    onFailed(errorInfo) {
      console.log('failed', errorInfo);
    },
    submit(values) {
      this.submitType = 'submit';
    },

    loginSuccess(res) {
      console.log('-------登录成功--------', res);
      this.loginShow = false;
      this.fetch();
    },

    loginCancel() {
      console.log('-------取消登录--------');
    },
  }
}
</script>



// WEBPACK FOOTER //
// SaiApplyFormStep1.vue?17142776